/**
 * Kézzel karbantartott AVIF/WebP variáns-térkép az üzletfotókhoz.
 *
 * Miért nem a `ResponsiveImage`: az a `<stem>-<szélesség>.<fmt>` névsémát várja,
 * ezek a fájlok viszont szélesség-utótag nélkül készültek (egy-méretű mesterek).
 *
 * Miért KÖZPONTI fájl: a térkép korábban a `StoreGallery.jsx`-ben élt. Amikor a
 * főoldali `StoreShowcase` is elkezdte ugyanezeket a fotókat használni, két
 * másolat keletkezett volna – egy új fotónál az egyiket el lehetne felejteni,
 * és a `<picture>` némán az eredeti JPEG-re esne vissza.
 *
 * Új fotónál: futtasd a `scripts/gen-image-variants.mjs`-t, és vedd fel ide.
 */
export const IMAGE_VARIANTS = {
  '/tescouzlet.jpg': { avif: '/tescouzlet.avif', webp: '/tescouzlet.webp' },
  '/uzlet-belvaros-kulso.jpg': { avif: '/uzlet-belvaros-kulso.avif', webp: '/uzlet-belvaros-kulso.webp' },
  '/uzlet-belvaros-belso.jpg': { avif: '/uzlet-belvaros-belso.avif', webp: '/uzlet-belvaros-belso.webp' },
  '/uzlet-belvaros-pult.jpg': { avif: '/uzlet-belvaros-pult.avif', webp: '/uzlet-belvaros-pult.webp' },
  '/uzlet-belvaros-varo.jpg': { avif: '/uzlet-belvaros-varo.avif', webp: '/uzlet-belvaros-varo.webp' },
  '/uzlet-tesco-belso.jpg': { avif: '/uzlet-tesco-belso.avif', webp: '/uzlet-tesco-belso.webp' },
  '/uzlet-tesco-vitrin.jpg': { avif: '/uzlet-tesco-vitrin.avif', webp: '/uzlet-tesco-vitrin.webp' },
  '/uzlet-tesco-varo.jpg': { avif: '/uzlet-tesco-varo.avif', webp: '/uzlet-tesco-varo.webp' },
};

export default IMAGE_VARIANTS;
